import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core'
import {CxDatePipe, LanguageService} from '@spartacus/core'
import {combineLatest, Subscription} from 'rxjs'
import { take } from 'rxjs/operators'
import {EbCountryService} from "../../../site-context/services/eb-country.service";
import { SalesDocument } from '../../interfaces/eb-order.interface'
import { EbOrderHistoryService } from '../../services/facades/eb-order-history.service'

@Component({
    selector: 'eb-order-history-component',
    templateUrl: './eb-order-history.component.html',
    styleUrls: ['./eb-order-history.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EbOrderHistoryComponent implements OnInit, AfterViewInit {
  salesDocuments: SalesDocument[] = []
  pageSize = 50
  currentPage = 0
  loading = false
  dataStructure$ = this.ebOrderHistoryService.getOrderHistoryTableStructure()
  countryChangeSubscription: Subscription;

  constructor(
    protected ebOrderHistoryService: EbOrderHistoryService,
    protected cd: ChangeDetectorRef,
    private readonly dateService: CxDatePipe,
    protected languageService: LanguageService,
    private readonly ebCountryService: EbCountryService
  ) {}

  ngOnInit(): void {
    this.fetchOrders()
    this.countryChangeSubscription = this.ebCountryService.countryChanged$.subscribe(() => {
      window.location.reload();
    });
  }

  ngAfterViewInit(): void {
    this.ebOrderHistoryService.orderHistoryPageLoaded()
  }

  nextPage() {
    this.currentPage++
    this.fetchOrders()
  }

  fetchOrders() {
    this.loading = true
    combineLatest([
      this.ebOrderHistoryService.getOrders(this.currentPage, this.pageSize),
      this.languageService.getActive()
    ])
      .pipe(take(1))
      .subscribe(([salesDocList]) => {
        this.loading = false
        this.salesDocuments = salesDocList?.salesDocList
          ? this.prepareSalesDocuments(salesDocList?.salesDocList)
          : []
        this.cd.detectChanges()
      })
  }

  prepareSalesDocuments(salesDocs: SalesDocument[]): SalesDocument[] {
    return salesDocs.map(doc => ({
      ...doc,
      createdAt: this.dateService.transform(doc.createdAt),
      statusCode: 'statusText.' + doc.statusTextId,
      shippingDate: this.dateService.transform(doc.shippingDate)
    }))
  }

  showPlaceholder(): boolean {
    return this.salesDocuments.length === 0 && this.loading === false
  }
}
